function appendCanonicalLink() {
  const existing = document.querySelector('link[rel="canonical"]');
  if (existing) existing.remove();

  const link = document.createElement("link");
  link.rel = "canonical";

  const path = window.location.pathname.replace(/\/$/, "") || "/";
  link.href = window.location.origin + path;

  document.head.appendChild(link);
}

appendCanonicalLink();
